import React from 'react';
import { Trans } from 'react-i18next';

export default function AssignedAssessorContent({ events, ownerChallenge = { name: 'Undefined' } }) {
  const allIdeas = [];
  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];
    const eventIdeas = event?.ownerIdeas || [];
    allIdeas.push(...eventIdeas);
  }
  return (
    <Trans i18nKey="notifications.assignedAssessor">
      You have been assigned to assess the idea{allIdeas.length > 1 ? 's' : ' '}
      <b>
        {{
          idea: `${allIdeas.map(
            (i, index) => {
              let name = (index < (allIdeas.length) && index !== 0) ? ' ' : '';
              name += (i.name || '[Deleted]');
              return name;
            },
          )}`,
        }}
      </b>
      in the challenge
      <b> {{ challenge: ownerChallenge.name }}</b>
    </Trans>
  );
}
